import React, { useRef } from 'react';

const OpenCloseTabs = () => {
  const openedTabsRef = useRef([]);

  const openNewTab = () => {
    const newTab = window.open('https://example.com', '_blank');
    if (newTab) {
      openedTabsRef.current.push(newTab);
    }
  };

  const closeAllTabs = () => {
    openedTabsRef.current.forEach((tab) => {
      if (!tab.closed) tab.close();
    });
    openedTabsRef.current = []; // Clear after closing
  };

  return (
    <div style={{ padding: '20px' }}>
      <button onClick={openNewTab}>Open Tab</button>
      <button onClick={closeAllTabs} style={{ marginLeft: '10px' }}>
        Close All Opened Tabs
      </button>
    </div>
  );
};

export default OpenCloseTabs;